import Vue from "vue";
import {axios} from "../plugins/http-axios";
import {Module} from "vuex";
import {RootState} from "@/store/index";
interface IDataColor{
    [key:string]:string
}
interface IColorState{
    color: IDataColor;
}
export default <Module<IColorState, RootState>>{
    state: {
        color: {},
    },
    mutations: {
        setDesignConfig(state, data:IDataColor) {
            state.color = data;
        },
    },
    actions: {
        getDesignConfig({commit, dispatch, rootGetters}):Promise<void> {
            return axios.get<IDataColor>(rootGetters.uri.designConfig)
                .then(resp => {
                    // localStorage.setItem('color', JSON.stringify(resp.data));
                    commit('setDesignConfig', resp.data);
                    return;
                })
                .catch(e => {
                    dispatch('setError', e);
                    return Promise.reject(e);
                });
        },
        initTypeColorSchema({getters}) {
            Vue.prototype.$vuetify.framework.theme.dark = getters.user.schemaDesign === 'DARK';
        },
        setTheme({state}) {
                Vue.prototype.$vuetify.framework.theme.themes.light = {
                    primary:  state.color.LKB_BG_COLOR_MAIN_WINDOW_LIGHT,
                    error: "#ff0d00",
                    secondary: "#b71c1c",
                    success: "#4caf50",
                    accent: "#bbdefb",
                    save: "#4caf50",
                    navbar: "#1976d2",
                    header: state.color.LKB_HEADER_COLOR_LIGHT,
                    sidebar: state.color.LKB_SIDEBAR_BG_COLOR_LIGHT,
                    btn_def: state.color.LKB_BTN_MAIN_COLOR_LIGHT,
                    icon_def: state.color.LKB_ICONS_MAIN_COLOR_LIGHT,

                    lkbBackgroundMainColor: state.color.LKB_BG_MAIN_COLOR_LIGHT,
                    headerColor: "#ddd",
                    lkbHeaderFontColor: state.color.LKB_HEADER_FONT_COLOR_LIGHT,
                    navbarColor: "#333",
                    footerColor: "#333",

                    checkColor: "#fb8c00",
                    radioColor: "#fb8c00",
                    breadcrumbs: state.color.LKB_BREADCRUMBS_FONT_COLOR_LIGHT,
                    selectColor: "#fb8c00",
                    inputColor: "#fb8c00",

                    applicationsColorManul: "#dae1e6",
                    applicationsColorStatusOk: "#ccffe6",
                    applicationsColorWarning: "#ffffcc",
                    applicationsColorUndefined: "#f0f8ff",
                    applicationsColorError: "#ff99bb",

                    applicationsColorAuthorizedPersons: "#edf3fc",
                    blackWhiteColors: "#ffffff",

                    customerDocumentsForCheck: "#ffffcc",
                    customerDocumentsValid: "#ccffe6",
                    customerDocumentsNotValid: "#eca7bd",
                    customerDocumentsProcess: "#b3ebf1",

                    ApplicationStatusesColor: "#d3d3d3",


                    LkbPicScanDoc: state.color.LKB_COLOR_TEXT_PICTURE_SCANNING_DOCS_LIGHT,
                    LkbColorDownlIcon: state.color.COLOR_ICON_DOWNLOAD_COLOR_LIGHT,
                    LkbColorScanIcon: state.color.COLOR_ICON_SCAN_COLOR_LIGHT,


                    LkbBgColorEntryPlate: state.color.LKB_BG_COLOR_ENTRY_PLATE_LIGHT,
                    LkbBgColorLoginButton: state.color.LKB_BG_COLOR_LOGIN_BUTTON_LIGHT,
                    LkbColorSupport: state.color.LKB_COLOR_SUPPORT_LIGHT,
                    LkbColorTextsAndElement: state.color.LKB_COLOR_TEXTS_AND_ELEMENTS_LIGHT,
                    lkbColorTableHeader: state.color.LKB_COLOR_TABLE_HEADER_LIGHT,
                    LkbColorLoginElement: state.color.LKB_COLOR_TEXTS_AND_ELEMENTS_LOGIN_LIGHT,

                    LkbColorPictureUploadingDocs: state.color.LKB_COLOR_PICTURE_UPLOADING_DOCS_LIGHT,
                    LkbColorTextUploadingDocs: state.color.LKB_COLOR_TEXT_PICTURE_UPLOADING_DOCS_LIGHT,
                    LkbColorLOADERBG: state.color.LKB_LOADER_BG_COLOR_LIGHT,
                    LkbColorCopy: state.color.LKB_COLOR_ELEMENTS_COPY_LIGHT,
                    lkbColorWarningMessage: state.color.COLOR_TEXT_WARNING_MESSAGE_LIGHT,
                    lkbBackgroundWarningMessage: state.color.COLOR_BACKGROUND_WARNING_MESSAGE_LIGHT,
                    lkbColorSuccessMessage: state.color.COLOR_TEXT_SUCCESS_MESSAGE_LIGHT,
                    lkbBackgroundSuccessMessage: state.color.COLOR_BACKGROUND_SUCCESS_MESSAGE_LIGHT,
                    lkbBackgroundColorTableManagerHeader: state.color.COLOR_BACKGROUND_TABLE_HEADERS_LIGHT,
                    lkbColorTableManagerHeader: state.color.COLOR_TEXT_TABLE_HEADERS_LIGHT,
                    lkbColorElementCreateDocument: state.color.LKB_COLOR_ELEMENT_CREATE_DOC_LIGHT,
                    lkbColorTextCreateDocument: state.color.LKB_COLOR_TEXT_CREATE_DOC_LIGHT
                };
                Vue.prototype.$vuetify.framework.theme.themes.dark = {

                    primary:  state.color.LKB_BG_COLOR_MAIN_WINDOW_DARK,
                    error: "#ff0d00",
                    secondary: "#b71c1c",
                    success: "#4caf50",
                    accent: "#bbdefb",
                    save: "#4caf50",
                    navbar: "#1976d2",
                    header: state.color.LKB_HEADER_COLOR_DARK,
                    lkbHeaderFontColor: state.color.LKB_HEADER_FONT_COLOR_DARK,
                    sidebar: state.color.LKB_SIDEBAR_BG_COLOR_DARK,
                    breadcrumbs: state.color.LKB_BREADCRUMBS_FONT_COLOR_DARK,
                    btn_def: state.color.LKB_BTN_MAIN_COLOR_DARK,
                    icon_def: state.color.LKB_ICONS_MAIN_COLOR_DARK,

                    lkbBackgroundMainColor: state.color.LKB_BG_MAIN_COLOR_DARK,
                    applicationsColorManul: "#8c98a1",
                    applicationsColorStatusOk: "#6da187",
                    applicationsColorWarning: "#adad80",
                    applicationsColorUndefined: "#b0b8bf",
                    applicationsColorError: "#ad617b",

                    applicationsColorAuthorizedPersons: "#b0b8bf",
                    blackWhiteColors: "#000000",

                    customerDocumentsForCheck: "#adad80",
                    customerDocumentsValid: "#7fb399",
                    customerDocumentsNotValid: "#ad7889",
                    customerDocumentsProcess: "#7dadb3",

                    ApplicationStatusesColor: "#9E9E9E",


                    LkbPicScanDoc: state.color.LKB_COLOR_TEXT_PICTURE_SCANNING_DOCS_DARK,
                    LkbColorDownlIcon: state.color.COLOR_ICON_DOWNLOAD_COLOR_DARK,
                    LkbColorScanIcon: state.color.COLOR_ICON_SCAN_COLOR_DARK,


                    LkbBgColorEntryPlate: state.color.LKB_BG_COLOR_ENTRY_PLATE_DARK,
                    LkbBgColorLoginButton: state.color.LKB_BG_COLOR_LOGIN_BUTTON_DARK,
                    LkbColorSupport: state.color.LKB_COLOR_SUPPORT_DARK,
                    LkbColorTextsAndElement: state.color.LKB_COLOR_TEXTS_AND_ELEMENTS_DARK,
                    lkbColorTableHeader: state.color.LKB_COLOR_TABLE_HEADER_DARK,
                    LkbColorLoginElement: state.color.LKB_COLOR_TEXTS_AND_ELEMENTS_LOGIN_DARK,

                    LkbColorPictureUploadingDocs: state.color.LKB_COLOR_PICTURE_UPLOADING_DOCS_DARK,
                    LkbColorTextUploadingDocs: state.color.LKB_COLOR_TEXT_PICTURE_UPLOADING_DOCS_DARK,
                    LkbColorLOADERBG: state.color.LKB_LOADER_BG_COLOR_DARK,
                    LkbColorCopy: state.color.LKB_COLOR_ELEMENTS_COPY_DARK,
                    lkbColorWarningMessage: state.color.COLOR_TEXT_WARNING_MESSAGE_DARK,
                    lkbBackgroundWarningMessage: state.color.COLOR_BACKGROUND_WARNING_MESSAGE_DARK,
                    lkbColorSuccessMessage: state.color.COLOR_TEXT_SUCCESS_MESSAGE_DARK,
                    lkbBackgroundSuccessMessage: state.color.COLOR_BACKGROUND_SUCCESS_MESSAGE_DARK,
                    lkbBackgroundColorTableManagerHeader: state.color.COLOR_BACKGROUND_TABLE_HEADERS_DARK,
                    lkbColorTableManagerHeader: state.color.COLOR_TEXT_TABLE_HEADERS_DARK,
                    lkbColorElementCreateDocument: state.color.LKB_COLOR_ELEMENT_CREATE_DOC_DARK,
                    lkbColorTextCreateDocument: state.color.LKB_COLOR_TEXT_CREATE_DOC_DARK
                };
        },
    },
    getters: {
        typeColorSchema: ():'dark'|'light' => Vue.prototype.$vuetify.framework.theme.dark ? 'dark' : 'light',
        theme: (state, getters):IDataColor => Vue.prototype.$vuetify.framework.theme.themes[getters.typeColorSchema],
        logoLoginImgW: (state):string => state.color.LKB_LOGO_IMAGE_WIDTH,
        logoLoginImgH: (state):string => state.color.LKB_LOGO_IMAGE_HEIGHT,
        headerLogoImgW: (state):string => state.color.LKB_HEADER_IMG_WIDTH,
        headerLogoImgH: (state):string => state.color.LKB_HEADER_IMG_HEIGHT,
        MIRROR_REFLECTION: (state):string => state.color.MIRROR_REFLECTION,
        HIDE_FIELD_SHADOW_LOGO: (state):string => state.color.HIDE_FIELD_SHADOW_LOGO,
        DISPLAY_ABOVE_BLOCK: (state):string => state.color.DISPLAY_ABOVE_BLOCK,
        dialogWhiteTextEnable: (state):boolean => state.color.DIALOG_COLOR_TEXT_WHITE === 'true',
    },
};
